import { useEffect } from 'react';
import useLatest from '../useLatest';
import { isFunction } from '../utils';

var useUnmount = function useUnmount(fn) {
  if (process.env.NODE_ENV === 'development') {
    if (!isFunction(fn)) {
      console.error("useUnmount expected parameter is a function, got " + typeof fn);
    }
  }

  var fnRef = useLatest(fn);
  useEffect(function () {
    return function () {
      fnRef.current();
    };
  }, []);
};

export default useUnmount;